import { Input } from "common/InputForm";
import { CustomModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import React, { useState } from "react";
import { selectedTicketReplyApi } from "services/help";
import { toastMessage } from "utils/toastMessage";
import {ValidateInput} from "validation";
import { support } from "validation/schema/support";

const ReplyHelpSupport = ({ replyModal, closeModal, selectedTicketData,setSupportTicketList }) => {
  const [inputData, setInputData] = useState({});
  const [error, setError] = useState({});
  const [buttonLoader, setButtonLoader] = useButtonLoader("Send");

  // Input Validation
  const validation = () => {
    const { errors, status } = ValidateInput(
      inputData,
      "replySupportSchema",
      support,
      null
    );
    setError(errors);
    return status;
  };

  const closeReplyModal = () => {
    setInputData({});
    setError({});
    closeModal();
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };



  //   const reply handler
  const replyHandler = async () => {
    if (validation()) {
      setButtonLoader(true);
      try {
        let reqData = {
          ticketId: selectedTicketData._id,
          message: inputData?.message,
        };
        const { data: responseData, status } = await selectedTicketReplyApi(
          reqData
        );
        if (status === 200) {
          setSupportTicketList((prevList) =>
            prevList.map((support) =>
              support._id === selectedTicketData._id
                ? { ...support, isReply: inputData?.message||""} 
                : support
            )
          );
          toastMessage(responseData?.message, "success", "reply");
          closeReplyModal();
        }
      } catch (e) {
        console.log("error:", e.error);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  return (
    <>
      <CustomModal show={replyModal} handleClose={closeReplyModal}>
        <h3>Reply Message</h3>
        <p>(It will be sent to their email)</p>
        <div className="form_field_wrap">
          <div className="form_field">
            <Input
              type="text"
              label="Reply"
              placeholder="Enter Message"
              name="message"
              value={inputData?.message || ""}
              onChange={changeHandler}
              error={error?.message}
            />
          </div>
        </div>
        <div className="button_wrap">
          <button
            type="button"
            className="button light"
            onClick={closeReplyModal}
          >
            Cancel
          </button>
          <button
            type="button"
            ref={buttonLoader}
            onClick={replyHandler}
            className="button"
          >
            Send
          </button>
        </div>
      </CustomModal>
    </>
  );
};

export default ReplyHelpSupport;
